import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import './AdminHubPage.css';
import '../styles/priceAlert.css';

// One card per page in the Despachos section.
const SECTIONS = [
  { to: '/despachos/remision', icon: '📝', label: 'Formulario de Remisión', desc: 'Registrar una nueva hoja de remisión (turno)' },
  { to: '/despachos/historial', icon: '📋', label: 'Historial de Remisiones', desc: 'Ver, editar y exportar las remisiones registradas' },
];

export default function DespachosPage() {
  // Sales whose remisiones' Cajas don't add up to the sale's (dispatch-referrals/box-mismatches/).
  const [mismatches, setMismatches] = useState(0);
  useEffect(() => {
    api.get('dispatch-referrals/box-mismatches/').then((r) => setMismatches(r.data.count)).catch(() => {});
  }, []);

  return (
    <div className="admin-hub-root">
      <h1 className="admin-hub-title hub-title-divided">🚛 Despachos</h1>
      {mismatches > 0 && (
        <div className="price-alert" role="alert">
          <span>
            ⚠️ {mismatches} {mismatches === 1 ? 'venta tiene' : 'ventas tienen'} remisiones cuyas cajas no suman lo vendido.
          </span>
          <Link to="/despachos/historial?descuadre=1" className="price-alert-btn">Revisar</Link>
        </div>
      )}
      {SECTIONS.length === 0 ? (
        <p className="admin-hub-empty">Aún no hay páginas en esta sección.</p>
      ) : (
        <div className="admin-hub-grid">
          {SECTIONS.map((s) => (
            <Link key={s.to} to={s.to} className="admin-hub-card">
              <span className="admin-hub-icon">{s.icon}</span>
              <div>
                <div className="admin-hub-label">{s.label}</div>
                <div className="admin-hub-desc">{s.desc}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
